import React from "react";
import { FormControlLabel, Switch, Typography } from "@mui/material";

const ToggleSwitch = ({
  label,
  isChecked,
  handleToggleChange,
  value,
  ...props
}) => {
  return (
    <>
      <Typography sx={{ pt: 1.5 }}>{label}</Typography>
      <FormControlLabel
        control={
          <Switch
            checked={isChecked}
            value={value}
            onChange={handleToggleChange}
            {...props}
          />
        }
      />
    </>
  );
};

export default ToggleSwitch;